module.exports = __webpack_public_path__ + "img/open-market-header-desktop.4d834156.jpg";